import { Space } from '../../atoms'
import PillLabel from '../../atoms/pillLabel/PillLabel'

export type PillLabelsStackProps = {
  labels: string[]
  px?: number
  py?: number
}

const PillLabelsStack = ({ labels, px, py }: PillLabelsStackProps) => {
  if (labels && labels.length > 0) {
    return (
      <Space
        isflex
        flexDirection="row"
        flexWrap={labels.length > 2 ? 'wrap' : 'nowrap'}
        px={px}
        py={py}
      >
        {labels.map(alert => (
          <PillLabel key={alert}> {alert}</PillLabel>
        ))}
      </Space>
    )
  }
  return null
}

export default PillLabelsStack
